import { ModuleTableOfContents } from 'types/learningHub/moduleContents';

export const isModuleCompleted = (data: ModuleTableOfContents | undefined) => {
  const allChaptersCompleted = data?.chapters?.every((chapter) =>
    chapter?.lessons?.filter((lesson) => lesson.kind === 'Test').every((test) => test?.status === 'Completed')
  );
  const allCertificationsCompleted = data?.certifications.every((certification) => certification?.status === 'Completed');
  return (allChaptersCompleted && allCertificationsCompleted) || false;
};

export const isModuleStarted = (data: ModuleTableOfContents | undefined) => {
  return data?.chapters?.flatMap((chapter) => chapter?.lessons).some((lesson) => lesson?.isCompleted) || false;
};
